module.exports = __webpack_public_path__ + "static/media/step2.e4475044.png";